module.exports = __webpack_public_path__ + "img/full.f7c082cb.png";